import { useNavigate } from 'react-router-dom';

type UpgradeReason = 'simulation_limit' | 'assistant_limit' | 'read_only';

interface UpgradeModalProps {
    reason: UpgradeReason;
    onClose: () => void;
}

export const UpgradeModal = ({ reason, onClose }: UpgradeModalProps) => {
    const navigate = useNavigate();

    const handleGoToPricing = () => {
        onClose();
        navigate('/pricing');
    };

    const getContent = () => {
        switch (reason) {
            case 'simulation_limit':
                return {
                    title: 'Simulation Limit Reached',
                    message: "You've reached the free plan limit of 1 simulation. Upgrade to Pro to create more profitability models and keep editing without removing existing work.",
                };
            case 'assistant_limit':
                return {
                    title: 'AI Assistant Limit Reached',
                    message: "You've used all 20 AI assistant requests on the free plan. Upgrade to Pro for more modeling assistance while building inputs, formulas, and scenarios.",
                };
            case 'read_only':
                return {
                    title: 'Account in Read-Only Mode',
                    message: 'Your account has been downgraded and you have multiple simulations. Upgrade to Pro to regain full editing capabilities.',
                };
            default:
                return {
                    title: 'Upgrade to Pro',
                    message: 'Unlock all features with a Pro subscription.',
                };
        }
    };

    const content = getContent();

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-dialog upgrade-modal" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close" onClick={onClose} aria-label="Close">
                    ×
                </button>

                <h2>{content.title}</h2>
                <p className="upgrade-modal-message">{content.message}</p>

                <div className="upgrade-modal-actions">
                    <button
                        className="btn btn-primary create-simulation-btn"
                        onClick={handleGoToPricing}
                    >
                        View Pricing Plans
                    </button>
                </div>
            </div>
        </div>
    );
};
